export default __webpack_public_path__ + "static/media/logo-small.d8ccdf6f.svg";